import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Context } from '../../../Context';
import { ApartmentViewContext } from '../context/ApartmentViewContext';
import { ReactComponent as IconChevron } from '../assets/icons/icon-chevron.svg';
import styles from '../../../styles/aprt.module.scss';
import buttons_styles from '../../../styles/buttons.module.scss';
import ToggleButtonsGroup from '../../_shared/ToggleButtonsGroup';

function ApartmentHeading() {
	const { t } = useTranslation();
	const {
		navigateToApartmentInDirectionHandler,
		filteredApartmentData,
		activeApartmentData,
	} = useContext(Context);
	const { setApartmentViewInteractions } = useContext(ApartmentViewContext);

	const numberOfFilteredApartments = filteredApartmentData
		? filteredApartmentData.length
		: 0;

	const handleApartmentChange = (direction) => {
		navigateToApartmentInDirectionHandler(direction);
		setApartmentViewInteractions((prev) => ({
			...prev,
			selectedCompartmentInd: null,
		}));
	};

	return (
		activeApartmentData && (
			<>
				<div
					style={{
						maxWidth: '30rem',
						minWidth: '28.5rem',
						display: 'flex',
						justifyContent: 'space-between',
						paddingBottom: '0.5rem',
					}}
				>
					<div className={styles.heading__block}>
						<h2
						// className={styles.heading__apartment}
						>
							{t('apartment_card')}
						</h2>
					</div>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<div className={styles.heading__block}>
							<ToggleButtonsGroup>
								<button
									className={buttons_styles['bim_button']}
									onClick={() => {
										handleApartmentChange(-1);
									}}
									disabled={numberOfFilteredApartments <= 1}
								>
									<IconChevron
										title="poprzedni lokal" //TODO: add to locales
										className={buttons_styles['bim_button__icon']}
										style={{ transform: 'rotate(180deg)' }}
									/>
								</button>
								{/* <div className={styles.heading__container}>
					<h2 className={styles.heading__apartment}>
					{activeApartmentData.id_original}
					</h2>
					</div> */}
								<button
									className={buttons_styles['bim_button']}
									onClick={() => {
										handleApartmentChange(1);
									}}
									disabled={numberOfFilteredApartments <= 1}
								>
									<IconChevron
										title="następny lokal" //TODO: add to locales
										className={buttons_styles['bim_button__icon']}
									/>
								</button>
							</ToggleButtonsGroup>
						</div>
					</div>
				</div>
			</>
		)
	);
}

export default ApartmentHeading;
